"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLocalizationProvider = void 0;
const gatsby_1 = require("gatsby");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const PageLocalizationContext_1 = require("./PageLocalizationContext");
const useGlobalLocalization_1 = require("../globalLocalization/useGlobalLocalization");
const PageLocalizationProvider = ({ children, pageContext: { locale, alternatives } }) => {
    const { localizationContext, changeLocale } = (0, useGlobalLocalization_1.useGlobalLocalization)();
    (0, react_1.useMemo)(() => {
        if (typeof locale === 'undefined') {
            console.warn('Missing locale in page context');
            return;
        }
        changeLocale(locale);
    }, [changeLocale, locale]);
    const navigateTranslated = (0, react_1.useCallback)((url, scrollPosition) => {
        if (!localizationContext.currentLocale)
            throw new Error('currentLocale has not yet been defined.');
        scrollPosition
            ? (0, gatsby_1.navigate)(localizationContext.currentLocale.localizePath(url), {
                state: { scrollPosition },
            })
            : (0, gatsby_1.navigate)(localizationContext.currentLocale.localizePath(url));
    }, [localizationContext.currentLocale]);
    const LinkTranslated = (0, react_1.useCallback)((props) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!props.url)
            return (react_1.default.createElement("div", { className: (_a = props === null || props === void 0 ? void 0 : props.className) !== null && _a !== void 0 ? _a : '', title: (_b = props === null || props === void 0 ? void 0 : props.title) !== null && _b !== void 0 ? _b : '' }, props.children));
        return (react_1.default.createElement(react_1.default.Fragment, null, props.target ? (react_1.default.createElement("a", { className: (_c = props === null || props === void 0 ? void 0 : props.className) !== null && _c !== void 0 ? _c : '', title: (_d = props === null || props === void 0 ? void 0 : props.title) !== null && _d !== void 0 ? _d : '', href: localizationContext.currentLocale.localizePath((_e = props === null || props === void 0 ? void 0 : props.url) !== null && _e !== void 0 ? _e : '/'), target: props.target, rel: 'noopener noreferrer' }, props.children)) : (react_1.default.createElement(gatsby_1.Link, { className: (_f = props === null || props === void 0 ? void 0 : props.className) !== null && _f !== void 0 ? _f : '', title: (_g = props === null || props === void 0 ? void 0 : props.title) !== null && _g !== void 0 ? _g : '', to: localizationContext.currentLocale.localizePath((_h = props === null || props === void 0 ? void 0 : props.url) !== null && _h !== void 0 ? _h : '/'), onClick: props.onClick }, props.children))));
    }, [localizationContext.currentLocale]);
    const shouldDisplayLanguageSwitcher = (0, react_1.useCallback)((pageUrl) => {
        // The list of pages where the localeSelector and localePopup should not be displayed
        const unallowedUrls = ['/reset-password/'];
        const localizedUnallowedUrls = unallowedUrls.map((url) => localizationContext.currentLocale.localizePath(url));
        if (localizedUnallowedUrls.includes(pageUrl))
            return false;
        return true;
    }, [localizationContext.currentLocale]);
    const currentLocaleDefinition = localizationContext.locales[locale];
    const contextValue = (0, react_1.useMemo)(() => {
        return {
            currentLocale: locale,
            currentLocaleDefinition,
            currentPageAlternatives: alternatives,
            navigateTranslated: navigateTranslated,
            localizePath: currentLocaleDefinition === null || currentLocaleDefinition === void 0 ? void 0 : currentLocaleDefinition.localizePath,
            localizePathSegment: currentLocaleDefinition === null || currentLocaleDefinition === void 0 ? void 0 : currentLocaleDefinition.localizePathSegment,
            LinkTranslated: LinkTranslated,
            shouldDisplayLanguageSwitcher: shouldDisplayLanguageSwitcher,
        };
    }, [
        locale,
        currentLocaleDefinition,
        alternatives,
        navigateTranslated,
        LinkTranslated,
        shouldDisplayLanguageSwitcher,
    ]);
    return (react_1.default.createElement(PageLocalizationContext_1.PageLocalizationContext.Provider, { value: contextValue },
        react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: localizationContext.i18next }, children)));
};
exports.PageLocalizationProvider = PageLocalizationProvider;
//# sourceMappingURL=PageLocalizationProvider.js.map